"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMoonFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M20.739 19.156c.591-.586.102-1.547-.71-1.67-2.89-.434-5.563-2.173-7.136-4.973a10.393 10.393 0 01-.56-8.995c.316-.78-.233-1.704-1.026-1.485C7.098 3.197 4 7.148 4 11.843 4 17.452 8.424 22 13.881 22c2.664 0 5.081-1.083 6.858-2.844z' }))); };
exports.default = SvgMoonFilled;
//# sourceMappingURL=MoonFilled.js.map